import { useMediaQuery } from "@/hooks/useMediaQuery";

/** Tracks `prefers-reduced-motion: reduce`. False during SSR and before mount. */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery("(prefers-reduced-motion: reduce)");
}
